/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    helpers = require('../utilities/handlebars').helpers,
    phoneify = require('../utilities/phoneify'),
    user = require('../models/user');

module.exports = Backbone.Model.extend({
    idAttribute: 'contactEmail',
    parse: function (results, options) {
        const result = _.isArray(results) ?  results[0] : results;
        if (result.organizationRoleTypeId) {
            result.organizationRole = helpers.enumL10n({property: 'organizationRoleTypeId', id: result.organizationRoleTypeId});
        }
        if (result.programRoleTypeId) {
            result.programRole = helpers.enumL10n({property: 'programRoleTypeId', id: result.programRoleTypeId});
        }
        result.phoneNumbersOnly = phoneify(result.phoneNumbersOnly);
        if (!result.contactEmail) {
            result.contactEmail = result.email;
        }
        return result;
    },
    sync: function (method, model, options) {
        const url = configuration.apiUrlBase + 'contact/',
            ajax = function (ajaxOptions) {
                jQuery.ajax(_.extend({
                    contentType: 'application/json',
                    dataType: 'json',
                    error: options.error,
                    headers: user.authorizationHeader('contact'),
                    success: options.success
                }, ajaxOptions));
            },
            methods = {
                create: function () {
                    ajax({
                        data: JSON.stringify(model.toJSON()),
                        method: 'POST',
                        url: url
                    });
                },
                delete: function () {
                    ajax({
                        method: 'DELETE',
                        url: url + model.id
                    });
                },
                update: function () {
                    ajax({
                        data: JSON.stringify(model.changed),
                        method: 'PUT',
                        url: url + model.id
                    });
                }
            };
        if (methods[method]) {
            methods[method](options);
        } else {
            Backbone.sync.apply(this, arguments);
        }
    },
    update: function (serializedForm) {
        const processedForm = formProcessor(serializedForm);
        this.set(processedForm);
        this.save();
    }
});
